/** Extract a Uint8ClampedArray of luma (Rec. 601) values from RGBA ImageData, in place-friendly form. */
export function toLuma(imageData: ImageData): Uint8ClampedArray {
  const { data, width, height } = imageData;
  const out = new Uint8ClampedArray(width * height);
  for (let i = 0, p = 0; p < out.length; i += 4, p++) {
    out[p] = 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
  }
  return out;
}

/** Pack a luma buffer back into an RGBA ImageData (R=G=B=luma), reusing the alpha channel from a source. */
export function lumaToImageData(luma: Uint8ClampedArray, width: number, height: number): ImageData {
  const data = new Uint8ClampedArray(width * height * 4);
  for (let p = 0, i = 0; p < luma.length; p++, i += 4) {
    const v = luma[p];
    data[i] = v;
    data[i + 1] = v;
    data[i + 2] = v;
    data[i + 3] = 255;
  }
  return new ImageData(data, width, height);
}
